import React from 'react';
import CustomCard from '../../../../Util/CustomCard';
import styles from "../ServiceRequestDetails.module.css";

const UserDetails = (props) => {
  return (
    <CustomCard styles={{marginTop:"10px"}}>
        {/* RCMC-08 (ticket 21): the card's title is a heading (it looks like one), with v1.2's look */}
        <h2 className={styles['card-title']} style={{padding:"10px",fontSize:"0.95rem",fontWeight:"bolder",borderBottom:"1px solid #ddd"}}>
            User Details
        </h2>
        <div style={{padding:"10px"}}>
            <div className={styles['details-row']}>
                <div className={styles['details-container']}>
                    <span className={styles['header']}>Name</span>
                    <span title={props.selectedRequest.created_by.name}>{props.selectedRequest.created_by.name}</span>
                </div>
                <div className={styles['details-container']}>
                    <span className={styles['header']}>Phone Number</span>
                    <span title={props.selectedRequest.created_by.phone_no}>{props.selectedRequest.created_by.phone_no}</span>
                </div>
            </div>
            <div className={styles['details-row']}>
                <div className={styles['details-container']}>
                    <span className={styles['header']}>PAN Number</span>
                    <span title={props.selectedRequest.created_by.pan_no}>{props.selectedRequest.created_by.pan_no}</span>
                </div>
                <div className={styles['details-container']}>
                    <span className={styles['header']}>Email ID</span>
                    <span title={props.selectedRequest.created_by.email}>{props.selectedRequest.created_by.email}</span>
                </div>
            </div>
        </div>
    </CustomCard>
  )
}

export default UserDetails
